import { createContext, useContext, useMemo, useState } from "react";

interface TableContext {
  refreshCounter: number;
  refreshData: () => void;
}
const TableContext = createContext<TableContext>({
  refreshCounter: 0,
  refreshData: () => {},
});

const ProvideTable = () => {
  const [refreshCounter, setRefreshCounter] = useState<number>(1);
  const refreshData = () => setRefreshCounter((prev) => prev + 1);

  return {
    refreshCounter,
    refreshData,
  };
};

const TableContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { refreshCounter, refreshData } = ProvideTable();

  return (
    <TableContext.Provider
      value={{
        refreshCounter,
        refreshData,
      }}
    >
      {children}
    </TableContext.Provider>
  );
};

const useTableContext = () => {
  return useContext(TableContext);
};

export { TableContextProvider, useTableContext };
